var _defs, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPedestrian(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    height: 80,
    width: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #6b9994;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #331e11;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #706f6f;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #4d7b8d;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: none;\r\n        stroke: #fff;\r\n        stroke-width: 2px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "No_mirror",
    "data-name": "No mirror"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.75,37.56c-.3,0-4.9,.3-4.8-2.8,.1-1.9,.6-2.8,4.1-3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.15,29.16c1.1-.2,1.3,1.6,2.8,1.2,1.3-.3-.4-1.7,2.7-2.1,1.3-.1,1.4-1.7,1.2-2.3-.4-2-5-1.4-6.4-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.15,43.36s3.3,.3,5.6,.8c2.9,.5,1.3,4.7-4.7,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M41.45,41.46s6.8,.5,9.5,1c1.9,.4,3.5,1.6,3.5,3.5h0c0,1.9-1.6,3.1-3.5,3.5s-9.5,.8-9.5,.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M36.15,30.76s-7.2,.7-10.2,1c0,0-1.1,1.2-.9,3.1,.2,1.9,1.3,2.8,1.3,2.8,3.3,.3,9.9,1,9.9,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.05,30.06c.4-.6,6-.9,6-.9v-4.8s-6.3-1.3-11.5-.7c-7,.8-7.4,9-7.5,11.7-.1,5.1,.5,9.3,1.1,12.5,.2,1.1-2.1,1.9-1.7,4.5,.3,2.2,4.1,3.4,7.2,3s5.4-2.6,6-4c3.8-8.8-.3-20.2,.4-21.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "MIRROR_bkg",
    "data-name": "MIRROR bkg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.35,39.46c0-4.3,3.5-7.1,7.9-7.1,3.5,0,6,1.5,7.5,4.6,.7,1.4,1.9,.9,1.9,2.5s-1.2,1.1-1.9,2.5c-1.5,3.1-4,4.6-7.5,4.6-4.4,0-7.9-2.8-7.9-7.1Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M29.25,30.5l2.5-5,4.5-2h6.5l5.25,.95m-18.75,6.05v8m0-8l-4,1m23-2.5c.4,.8,1.83,1.33,2.5,1.5h1.5l-.5-1.5h2.5l1-1.5-1-2-1-1h-5l-.25-.05m.25,4.55c-.4-.8-3.5,0-5,.5h-.5l-1,1,1,2.5m5.5-4l-.25-4.55m-5.25,8.55l3.5,2.5,1,3h1.5v2.5l-.75,.5m-5.25-8.5l-4-1-3,1-3,2-1,3.5v2.5l1.5,4,5.5,2,4-.5m0,0l3.5-2.5,1-2,.75-.5m-5.25,5v3.5m5.25-8.5l4.25,1,2,1.5m0,0v2.5l-.5,2m.5-4.5l1.5-.5,3,1.5v2l-2.5,1.5h-2.5m0,0l-2,1.5h-9m0,0l-3,3.5-3,2-4,1-2.5-1-2.5-2,.5-3,2-2.5-1-8v-1.5m0,0l-4-.89m0-6.11l-2.5,1.5-1.5,2,1.5,2,2,.5,.5,.11m0-6.11l-.5,3.5,.5,2.61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPedestrian);
export default __webpack_public_path__ + "static/media/pedestrian.4b42d91941be285991eea01afea06282.svg";
export { ForwardRef as ReactComponent };